import { array, object, string } from 'yup';

import { arrayUniqueBy } from '../../shared/functions/array-unique-by';
import { IValidatorConfig } from '../types/validator-config.interface';

export const validatorConfigSchema = object<IValidatorConfig>({
  type: string().trim().required(),
  args: object().nullable().optional(),
  expression: string().trim().optional(),
});

export const validatorConfigsSchema = array<IValidatorConfig>()
  .required()
  .test({ name: 'type', message: 'type is not unique', test: arrayUniqueBy('type') })
  .of(validatorConfigSchema.required())
  .min(1);
